import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { deleteNotice } from "../api/notice";
import { DeleteNotice } from "../types/types";
import { useSnackbar } from "notistack";

const useDeleteNotice = ({ idx }: DeleteNotice) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: () => deleteNotice({ idx }),

    onSuccess: (data) => {
      // console.log(data);
      navigate(-1);
      enqueueSnackbar(data.message, {
        variant: "success",
      });
    },
  });
  return mutation;
};

export default useDeleteNotice;
